import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { Formatters, Messages } from '../../../../codegen/Localize';
import { L10n } from '../../../../commonInfra/L10n/L10n';
import { OrderKeys } from '../../../models/OrderKeys';
import { StyledCellFormatter } from '../StyledCellWrapper';

interface DateTimeOptions {
  row: DataGrid.Row;
  propertyName: string;
  nullDateTimeLabel?: string;
}

export function DateTimeText(options: DateTimeOptions): string {
  const dateTime = options.row.data[options.propertyName];

  if (options.propertyName === OrderKeys.lastAccessedAt ||
      options.propertyName === OrderKeys.sharedAt) {
    return dateTime ? Formatters.formatLongBestFitRelativeTime(new Date(dateTime)) : (options.nullDateTimeLabel || '');
  }

  return dateTime ? L10n.localizedDateTime(dateTime) : options.nullDateTimeLabel || '';
}

function DateTooltip(options: DateTimeOptions): string {
  const dateTime = options.row.data[options.propertyName];

  if (options.propertyName === OrderKeys.lastAccessedAt ||
      options.propertyName === OrderKeys.sharedAt) {
    return dateTime ? L10n.localizedDateTime(dateTime) : '';
  }

  return '';
}

export function DateTimeCell(propertyName: string, nullDateTimeLabel?: string): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function DateTimeCell(props: BodyCell.Props) {
        const options = {...props, propertyName, nullDateTimeLabel};
        return (
            <span title={DateTooltip(options)}>
          {DateTimeText(options)}
        </span>
        );
      }
  );
}

export function OverridableDateTimeCell(dateProperty: string, overrideProperty: string,
                                        overrideLabel?: string, testId?: string): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function OverridableDateTimeCell(props: BodyCell.Props) {
        const override = props.row.data[overrideProperty];
        const dateTime = props.row.data[dateProperty];
        // show the overrideLabel if the override is true no matter the value of dateTime
        const text = !override && dateTime ? L10n.localizedDateTime(dateTime) : overrideLabel;
        return (
            <span data-tb-test-id={testId}>{text}</span>
        );
      }
  );
}

export function JobRequestedTimeCell(propertyName: string, nullDateTimeLabel: string): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function JobRequestedTimeCell(props: BodyCell.Props) {
        const dateTime = props.row.data[propertyName];
        const jobRetentionDays = props.row.data['jobRetentionDays'];

        let displayText: string;
        if (dateTime) {
          const options = {...props, propertyName, nullDateTimeLabel};
          displayText = DateTimeText(options);
          return (
            <span title={DateTooltip(options)}>{displayText}</span>
          );
        } else if (jobRetentionDays != null) {
          displayText = Messages.jobRetentionDaysOlderThan({ DAYS: jobRetentionDays });
        } else {
          displayText = nullDateTimeLabel;
        }

        return (
            <span>{displayText}</span>
        );
      }
  );
}
